import { c as _c } from "react/compiler-runtime";
import type { Address, ChainId } from '@morpho-org/blue-sdk';
import { InterfaceChainUtils } from '@morpho-org/dapp-core';
import { ClipboardButton } from '@morpho-org/ui-v6/client';
import { Tooltip, TooltipContent, TooltipTrigger } from '@repo/ui';
import { ArrowDiagonalUp } from '@repo/ui/icons';
import { memo } from 'react';
import { ButtonLink } from '@/components/common/ButtonLink';
import { useIsMobile } from '@/hooks/useBreakpoints';
interface GuardianAddressActionsProps {
  address: Address;
  addressLink: string | null;
  chainId: ChainId;
}
const GuardianAddressActions = t0 => {
  const $ = _c(9);
  const {
    address,
    addressLink,
    chainId
  } = t0;
  const isMobile = useIsMobile();
  let t1;
  if ($[0] !== address) {
    t1 = <ClipboardButton toCopy={address} toastMessage="Guardian address copied to clipboard." tooltipMessage="Copy guardian address." aria-label="Copy guardian address" />;
    $[0] = address;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== addressLink || $[3] !== chainId || $[4] !== isMobile) {
    t2 = addressLink && <Tooltip><TooltipTrigger asChild={true}><div className="flex"><ButtonLink href={addressLink} buttonProps={{
            onClick: _temp,
            variant: "ghost",
            size: "sm",
            iconRight: undefined,
            iconAlone: <ArrowDiagonalUp />,
            iconAloneProps: {
              className: "text-secondary-foreground"
            }
          }} /></div></TooltipTrigger>{!isMobile && <TooltipContent>{`Go to ${InterfaceChainUtils.tryGetChain(chainId)?.blockExplorers?.default.name || "block explorer"}.`}</TooltipContent>}</Tooltip>;
    $[2] = addressLink;
    $[3] = chainId;
    $[4] = isMobile;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className="flex items-center">{t1}{t2}</div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};
export default memo(GuardianAddressActions);
function _temp(e) {
  return e.stopPropagation();
}